import { useEffect, useState } from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Header from "../components/Header";
import NewsListing from "../components/NewsListing";
import axios from "axios";

const NewsPage = ({ page, initialPosts }) => {
  const [posts, setPosts] = useState(initialPosts);
  const acf = page[0].acf;
  const title = "News";
  const description = acf.intro ?? "";

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const wpUrl = process.env.NEXT_PUBLIC_WORDPRESS_URL ?? "https://longlead-cms.decimalstudios.com";
        const postsUrl = `${wpUrl}/wp-json/wp/v2/posts`;
        const response = await axios.get(postsUrl, {
          headers: { "Content-Type": "application/json" },
        });
        setPosts(response.data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    
    fetchPosts();
  }, []);

  return (
    <div>
      <Head>
        <title>{title} - Long Lead</title>
        <meta property="og:title" content={title + " - Long Lead"} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title + " - Long Lead"} />
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="https://longlead.com/LL_FB_5.png" />
        <link rel="canonical" href="https://longlead.com/privacy-policy" />
      </Head>
      <Header />
      <main className="main-container">
        <NewsListing news={posts} copy={description} title={title} />
        <div id="footer-trigger" />
      </main>
      <Footer />
    </div>
  );
};

export const getStaticProps = async () => {
  const wpUrl = process.env.NEXT_PUBLIC_WORDPRESS_URL ?? "https://longlead-cms.decimalstudios.com";

  const postsUrl = `${wpUrl}/wp-json/wp/v2/posts`;
  const postsRes = await axios.get(postsUrl, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  const pageUrl = `${wpUrl}/wp-json/wp/v2/pages?slug=news`;
  const pageRes = await axios.get(pageUrl, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return {
    props: {
      page: pageRes.data,
      initialPosts: postsRes.data,
    },
    revalidate: 600, 
  };
};

export default NewsPage;
